// Image resizing constraints for OpenAI API
// Images are resized to fit within these dimensions to optimize API usage
export const MAX_IMAGE_LONG_SIDE = 2048;
export const MAX_IMAGE_SHORT_SIDE = 768;

// File upload constraints
export const MAX_FILES_PER_UPLOAD = 10;
export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024; // 20MB
